"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    en: {
        api: {
            errors: {
                AlreadyVerifiedError: "Your account is already verified!",
                CaseInProgressError: "The case is already in progress!",
                CaseNotInProgressError: "The case is either not in progress yet or has already been resolved!",
                ExpiredPhoneNumberTokenError: "Expired phone number token!",
                InitialMessagesCanOnlyBeRetrievedOnPendingCaseError: "Initial messages can only be retrieved on pending cases!",
                InvalidConversationStatusError: "Invalid conversation status!",
                InvalidInviteCode: "Your invite code is invalid!",
                InvalidNotificationTokenError: "Invalid notification token!",
                InvalidPhoneNumberTokenError: "Invalid phone number token!",
                InvalidRefreshTokenError: "Invalid refresh token!",
                MessageNotFoundError: "Message not found!",
                MustBeClientError: "You must be a client to access this resource!",
                MustBeLawyerError: "You must be a practitioner to access this resource!",
                NoAccessToConversationError: "You do not have access to this conversation!",
                NoAccessToMessageError: "You do not have access to this message!",
                NoConversationExistsWithIdError: "No conversation with the provided ID exists!",
                NoPhoneNumberTokenExistsForUser: "Could not find a valid phone number token for the requested user!",
                NoUserExistsWithIdError: "No User with the provided ID exists!",
                NotLoggedInError: "You are not logged in!",
                NotVerifiedError: "Your account must be verified!",
                OnlyTextMessageAllowedInLookingForLawyerError: "You can only send text messages right now! You will be able to send voice and image messages once you get paired up with a practitioner!",
                TooManyPhoneNumberTokenRequestsError: "You are sending too many phone number token requests! Please wait a few minutes before trying again.",
                UndoTimeRanOutError: "Your undo window has expired!",
            },
        },
        components: {
            audioRecorder: {
                noMicrophoneFound: "Cannot start recording. No microphone found!",
                startedRecording: "Started recording...",
            },
        },
        conversation: {
            category: {},
            status: {
                inProgress: "Under Review by a {{lawyerTitle}}",
                inProgressShort: "Under Review",
                informationGathering: "Information Intake",
                lookingForLawyer: "Analyzing Inquiry",
                resolved: "Resolved",
                unresolved: "Unresolved",
            },
            topic: {},
        },
        notifications: {
            messageTypes: {
                audio: "audio",
                image: "image",
                text: "text",
            },
            newMessageTitle: 'New {{messageType}} message in conversation "{{conversationTitle}}"',
        },
        server: {
            sms: {
                verificationMessage: "Your registration code is {{code}}. It will expire {{expiration}}.",
            },
        },
        ui: {
            banner: {
                close: "Close",
            },
            components: {
                messageInputBar: {
                    imageAttachedLabel: "Image",
                    imageWithNameAttachedLabel: "Image: {{fileName}}",
                    recordingLabel: "Audio: {{duration}}s",
                    textPlaceholder: "Message...",
                },
            },
            form: {
                errorPlural: "Errors",
                errorSingular: "Error",
            },
            header: {
                faqButton: "FAQ",
            },
            loading: "Loading...",
            navigation: {
                tabBar: {
                    acceptConversation: "Accept Inquiry",
                    conversations: "Inquiries",
                    createConversation: "Start Inquiry",
                    messages: "Inquiry",
                    profile: "Profile",
                },
            },
            screen: {
                acceptConversation: {
                    caseAcceptButton: "Accept",
                    caseDeclineButton: "Decline",
                },
                authenticate: {
                    invitePlaceholder: "Invite Code",
                    phoneNumberPlaceholder: "Phone Number",
                    registerText: "Enter your phone number and press enter to login",
                    successfullyRegisteredMessage: "You have successfully registered!",
                    tokenPlaceholder: "Token",
                    verficationBanner: {
                        text: "You have not verified your account yet. Please enter your verification code.",
                    },
                },
                conversations: {
                    searchBarPlaceholder: "Search",
                },
                createConversation: {
                    searchBarPlaceholder: "Search topics...",
                    selectTopicCategory: {
                        header: "Please select your topic",
                    },
                    writeDescription: {
                        categoryHeader: "Category",
                        descriptionHeader: "Description",
                        descriptionPlaceholder: "Briefly describe your problem here...",
                        submitButton: "Submit",
                        topicHeader: "Topic",
                    },
                },
                gettingStarted: {
                    title: "Here are some example question prompts...",
                },
                messages: {
                    changedStatusToLFLMessage: "Successfully submitted your inquiry!",
                    checkmarkHoverMessageClient: "Submit the inquiry to ProSay",
                    checkmarkResolveHover: "Resolve and close the current case.",
                    checkmarkUnresolveHover: "Unresolve the current case.",
                    clipboard: {
                        canOnlySaveTextMessages: "We can only save text messages to clipboard!",
                        savedToClipboard: "Message saved to your clipboard!",
                    },
                    confidentialityNotice: "Remember that the person on the other side of the line is NOT YOUR ATTORNEY and has no duty to keep your information confidential or to not represent parties whose interests are adverse to you.",
                    headerButtons: {
                        resolve: "RESOLVE",
                        submit: "SUBMIT",
                        unresolve: "UNRESOLVE",
                    },
                    inProgressPrompt: "Your case is currently being reviewed and resolved by a {{lawyerTitle}}. Please make sure to provide any information that the practitioner requests.",
                    inProgressPromptNoTitle: "Your case is currently being reviewed and resolved by a practitioner. Please make sure to provide any information that the practitioner requests.",
                    informationGatheringPrompt: "Please include all relevant information about your case, but ensure that you do not include any confidential information. Once you've sent all relevant information, press the checkmark on the top right to submit your inquiry to us.",
                    lookingForLawyerPrompt: "We have submitted your inquiry to our practitioners. You may continue to send, remove, or modify your text messages. Once we have matched you with a practitioner, you will be able to use image and voice messages as well.",
                    messageActionSheet: {
                        options: {
                            cancel: "Cancel",
                            copy: "Copy",
                            delete: "Delete",
                            edit: "Edit",
                        },
                        title: "Message Actions",
                    },
                    successfullyRemovedMessage: "Successfully removed message!",
                    successfullyResolvedCaseMessage: "Successfully resolved case!",
                    successfullyUnresolvedCaseMessage: "Unresolved case!",
                },
                profile: {
                    copiedToClipboardMessage: "Copied {{data}} to your clipboard!",
                    loggedOutMessage: "You have successfully logged out!",
                    menu: {
                        accountInformationTitle: "Account Information",
                        accountSettingsTitle: "Account Settings",
                        accountType: "Account Type",
                        logout: "Log Out",
                        phoneNumber: "Phone Number",
                        userId: "User ID",
                    },
                },
            },
        },
        user: {
            client: "User",
            lawyer: "Practitioner",
        },
        validation: {
            labels: {
                conversationMessageContent: "Message",
                conversationQuestion: "Inquiry",
                inviteCode: "Practitioner Invite Code",
                phoneNumber: "Phone Number",
                phoneNumberVerificationToken: "Phone Number Verification Token",
            },
            messages: {
                invalidDateInput: "{{value}} is not a valid date input. ",
                invalidInviteToken: "{{value}} is not a valid practitioner invite token.",
                invalidNotificationToken: "{{value}} is not a valid notification token.",
                invalidPhoneNumber: "{{value}} is not a valid phone number.",
                invalidPhoneNumberToken: "{{value}} is not a valid phone number validation token.",
                invalidUuid: "{{value}} is not a valid UUID.",
            },
        },
    },
};
//# sourceMappingURL=data:application/json;base64,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